import { ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, Input, Renderer2, ViewChild } from '@angular/core';
import { dismiss } from '@ionic/core/dist/types/utils/overlays';
import { ModalController, IonSlides, ToastController } from '@ionic/angular';
import { ActualizacionServiceService } from 'src/app/services/actualizacion/Actualizacion-service.service';

import Swal2 from "sweetalert2";
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { LkfilmViewBySlidesComponent } from 'src/app/components/lkfilm-view-by-slides/lkfilm-view-by-slides.component';
import { RequestService } from 'src/app/services/request/request.service';
import { Router } from '@angular/router';
import { slugifySeoValue } from 'src/app/utils/seo-slug';

@Component({
  selector: 'app-Coleccion-regalos',
  templateUrl: './Coleccion-regalos.html',
  styleUrls: ['./Coleccion-regalos.scss'],
})
export class ColeccionRegalos implements OnInit {
  slideOpts = {
    direction: 'vertical',
    initialSlide: 0,
    speed: 420,
  };
  public publications: any[] = [];
  public ChunkedPublications: any[] = [];
  @Input() profile_id: any;
  @Input() initial_index = 0;
  @Input() feex_likes = false;
  @Input() wishlistFilter: 'listing' | 'event' | 'product' | null = null;
  @ViewChild('slides') slides: IonSlides;
  @ViewChild('wishlistCardHost') wishlistCardHost?: ElementRef<HTMLElement>;
  public wishlistItems: any[] = [];
  public wishlistLoading = false;
  public wishlistError = '';

  constructor(
    private modalctrl: ModalController,
    private actualizacionservice: ActualizacionServiceService,
    private toastController: ToastController,
    private formService: FormServiceService,
    private request: RequestService,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private ngZone: NgZone,
    private renderer: Renderer2,
  ) { }

  ngOnInit() {
    if (this.feex_likes) {
      this.loadWishlist();
    } else {
      this.getpublicationgifted(true);
    }
    console.log('user_id guardado', this.profile_id);
  }

  favoriteTypeLabel(item: any): string {
    const type = this.favoriteType(item);
    if (type === 'listing') return 'Hospedaje Terra';
    if (type === 'event') return 'Events Eclipse';
    return 'FEEX Wholesale';
  }

  get wishlistTitle(): string {
    if (this.wishlistFilter === 'listing') return 'Favoritos Earth';
    if (this.wishlistFilter === 'event') return 'Favoritos Eclipse';
    return 'Favoritos FEEX';
  }

  favoriteTitle(item: any): string {
    return item?.product_name || item?.name || item?.title || item?.product_title || `Producto FEEX #${item?.id || ''}`;
  }

  favoriteImage(item: any): string {
    return item?.item_image || item?.image || item?.image_url || item?.product_image ||
      'https://laniakea-multimedia.s3.amazonaws.com/laniakea.tv/Sin+resultados-2-2.gif';
  }

  async openFavorite(item: any): Promise<void> {
    const type = this.favoriteType(item);
    const title = String(item?.product_name || 'item');
    let target: string;

    if (type === 'listing') {
      const city = String(item?.item_subtitle || '').split(',')[0].trim();
      target = `/earth/${slugifySeoValue([title, city].filter(Boolean).join(' '))}`;
    } else if (type === 'event') {
      target = `/eventos-eclipse-view/${slugifySeoValue(title)}`;
    } else {
      target = `/feex-wholesale/${slugifySeoValue(title) || 'producto'}?product_id=${encodeURIComponent(item?.product_id || '')}`;
    }

    await this.modalctrl.dismiss();
    await this.router.navigateByUrl(target);
  }

  private favoriteType(item: any): 'product' | 'event' | 'listing' {
    if (['product', 'event', 'listing'].includes(item?.item_type)) return item.item_type;

    // Compatibility for CarPlay favorites saved before catalog metadata was
    // persisted. Guesty listing IDs are 24-character hexadecimal values;
    // FEEX IDs are numeric, leaving the remaining legacy IDs as events.
    const id = String(item?.product_id || '');
    if (/^[a-f0-9]{24}$/i.test(id)) return 'listing';
    if (/^\d+$/.test(id)) return 'product';
    return 'event';
  }

  async loadWishlist() {
    this.updateWishlistView([], true, '');
    try {
      let response: any = await Promise.race([
        this.request.createRequestPost('add_products_to_wishlist', { get_cart: true }),
        new Promise((_, reject) => setTimeout(() => reject(new Error('Wishlist request timed out')), 10000)),
      ]);
      console.log('[FEEX wishlist] response', response);
      response = this.parseApiResponse(response);
      const candidates = [
        response?.wishlist_items,
        response?.data?.wishlist_items,
        response?.cart_items,
        response?.data?.cart_items,
        response?.items,
        response?.data?.items,
        response,
      ];
      const collection = candidates.find((candidate) => this.isCollection(candidate));
      const serverItems = this.collectionToArray(collection);
      console.log('[FEEX wishlist] parsed items', serverItems);
      const visibleItems = this.wishlistFilter
        ? serverItems.filter((item) => this.favoriteType(item) === this.wishlistFilter)
        : serverItems;
      this.updateWishlistView(visibleItems, false, '');
    } catch (error) {
      console.error('Wishlist could not be loaded:', error);
      this.updateWishlistView(
        [],
        false,
        'No se pudo cargar tu lista de deseos. Revisa tu sesión e inténtalo otra vez.',
      );
    }
  }

  /**
   * RequestService resolves its fetch promise outside Angular in this modal.
   * Re-enter the Angular zone so the *ngIf and *ngFor bindings render the
   * parsed items immediately.
   */
  private updateWishlistView(items: any[], loading: boolean, error: string): void {
    this.ngZone.run(() => {
      this.wishlistItems = items;
      this.wishlistLoading = loading;
      this.wishlistError = error;
      this.changeDetectorRef.detectChanges();
      this.renderWishlistCards();
    });
  }

  private renderWishlistCards(): void {
    const host = this.wishlistCardHost?.nativeElement;
    if (!host) return;

    while (host.firstChild) this.renderer.removeChild(host, host.firstChild);
    this.wishlistItems.forEach((item) => {
      const card = this.renderer.createElement('div');
      this.renderer.addClass(card, 'wishlist-card');
      this.renderer.setAttribute(card, 'role', 'button');
      this.renderer.setAttribute(card, 'tabindex', '0');
      this.renderer.listen(card, 'click', () => { void this.openFavorite(item); });
      this.renderer.listen(card, 'keydown', (event: KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          void this.openFavorite(item);
        }
      });

      const image = this.renderer.createElement('img');
      this.renderer.setAttribute(image, 'src', this.favoriteImage(item));
      this.renderer.setAttribute(image, 'alt', this.favoriteTitle(item));
      this.renderer.appendChild(card, image);

      const copy = this.renderer.createElement('div');
      this.renderer.addClass(copy, 'wishlist-card__copy');
      this.appendCardText(copy, item.item_type || 'product', 'wishlist-card__type');
      this.appendCardText(copy, item.product_name, 'wishlist-card__title');
      this.appendCardText(copy, `Product ID: ${item.product_id}`);
      this.appendCardText(copy, `$${item.price}`);
      this.renderer.appendChild(card, copy);

      const heart = this.renderer.createElement('span');
      this.renderer.addClass(heart, 'wishlist-card__heart');
      this.renderer.appendChild(heart, this.renderer.createText('♥'));
      this.renderer.appendChild(card, heart);
      this.renderer.appendChild(host, card);
    });
  }

  private appendCardText(parent: any, value: any, className?: string): void {
    const element = this.renderer.createElement(className === 'wishlist-card__title' ? 'strong' : 'span');
    if (className) this.renderer.addClass(element, className);
    this.renderer.appendChild(element, this.renderer.createText(String(value || '')));
    this.renderer.appendChild(parent, element);
  }

  private parseApiResponse(response: any): any {
    let parsed = response;
    for (let depth = 0; depth < 3 && typeof parsed === 'string'; depth += 1) {
      try {
        parsed = JSON.parse(parsed);
      } catch {
        break;
      }
    }
    return parsed;
  }

  private isCollection(value: any): boolean {
    if (Array.isArray(value)) return true;
    if (!value || typeof value !== 'object') return false;
    return Object.keys(value).some((key) => /^\d+$/.test(key));
  }

  private collectionToArray(value: any): any[] {
    if (Array.isArray(value)) return value;
    if (!value || typeof value !== 'object') return [];
    return Object.keys(value)
      .filter((key) => /^\d+$/.test(key))
      .sort((left, right) => Number(left) - Number(right))
      .map((key) => value[key]);
  }

  

  retorno(){
    this.modalctrl.dismiss()
  }
  get_class2(index) {
    // console.log('se lllama get_class2');

    if(this.formService.lkpublication.index_close===index){
      return 'shadow'
    }


  }
  getpublicationsave2(){

    this.actualizacionservice.getPublicationsSave(this.profile_id, null ).then((result:[])=>{



     result['data'].forEach(element => {


        console.log("elementos",element);
        this.ChunkedPublications.push(element)


      });
      console.log("publicaciones Guardadas",this.ChunkedPublications);
      this.chunkPublications();
    })
  }

  
  
  

  ngAfterViewInit() {
    this.renderWishlistCards();
    if (this.feex_likes || !this.slides) {
      return;
    }
    this.slides.slideTo(this.initial_index);
    this.slides.ionSlideDidChange.subscribe(async () => {
      await this.handleSlideChange();
    });
     let me = this;
     me.slides.slideTo(this.initial_index);
  }
  private chunkPublications() {
    const chunkSize = 4;
    const chunkedPublications = [];
    let index = 0;
  
    while (index < this.ChunkedPublications.length) {
      const chunk = this.ChunkedPublications.slice(index, index + chunkSize);
      if (chunk.length > 0) {
        chunkedPublications.push(chunk);
      }
      index += chunkSize; // Update the index by the chunkSize, not the chunk length
    }
  
    this.ChunkedPublications = chunkedPublications;
  }
  
  async handleSlideChange() {
    const currentIndex = await this.slides.getActiveIndex();
  
    // Check if the current slide is the last slide
    if (currentIndex === (await this.slides.length() - 1)) {
      // Fetch more publications when reaching the last slide
     
  
       await this.new_page();
    }
  }
  async new_page() {
    try {
      this.showToast();
      this.actualizacionservice.current_page++;
      const fetchedPublications = await this.actualizacionservice.getPublicationsGifted(null, false, null, false, null);
    
      if (!fetchedPublications || fetchedPublications.length === 0) {
        Swal2.fire({
          title: 'Your finger swipe speed exceeded the limit',
          icon: 'warning',
          confirmButtonText: 'Understood',
          color: '#ffffff',
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
        });
        return;
      }
    
      const chunkedPublications = this.chunkNewPublications(fetchedPublications);
      this.ChunkedPublications.push(...chunkedPublications);
    } catch (error) {
      console.error('Error fetching publications:', error);
    }
    
  }
  async showToast() {
    const toast = await this.toastController.create({
      message: `
        <div class="toast-content">
        <img src="https://laniakea-multimedia.s3.amazonaws.com/loading_chunk.gif" alt="Image" style="width: 100px; height: 30px;">
          <span>⚡️⚡️⚡️</span>
        </div>
      `,
      duration: 6399,
      position: 'bottom',
      cssClass: 'custom-toast',
      buttons: [
        {
          text: '...',
          role: 'cancel'
        }
      ]
    });
  
    toast.present();
  }
  
  chunkNewPublications(publications) {
    const chunkSize = 4; // Define your desired chunk size here
    const chunkedArray = [];
    
    for (let i = 0; i < publications.length; i += chunkSize) {
      const chunk = publications.slice(i, i + chunkSize);
      chunkedArray.push(chunk);
    }
    
    return chunkedArray;
  }


  async getpublicationgifted(isrefresh: boolean){
    const result = await this.actualizacionservice.getPublicationsGifted(null, isrefresh, this.profile_id, null, null) ;
    const fetchedPublications = result || [];

    
    this.filterPublications(fetchedPublications);
    
  }
  async filterPublications(publications) {
  
    if (publications.length > 0) {
      this.publications = publications;
      this.ChunkedPublications = publications;
      this.chunkPublications();
    }
    if (publications.length < 1 && this.actualizacionservice.current_page < 3) {
      console.log('pub < x');
      this.actualizacionservice.current_page++;
      await this.getpublicationgifted(false);
    }
  
    console.log('siguiendo length of pub', this.ChunkedPublications.length);
  
  
  }
  get_class(index) {
    // console.log('se lllama get_class');


    if((index % 4 === 0)) {
      return 'reminder0 ';
    }
    else if(index % 4 === 1){
      return 'reminder1 ';
    }
    else if(index % 4 === 2){
      return 'reminder2 ';
    }else{
      return 'reminder3 ';
    }
  }
  openComponentVideoTry(index, chunk){//
    console.log('chunkk',chunk);
    console.log('indexxx',index);
    const indexxx = chunk * 4 + index;
      this.modalctrl.create({
          component: LkfilmViewBySlidesComponent,
          cssClass: 'detailsInModal',
          canDismiss: true, // (forced globally for swipe close on all modals)
          componentProps: {
            publications: this.publications,
            index: indexxx,
            valueSelect: 'ColeccionRegalos'
          }
      }).then((modal)=>{
          modal.present();
      });
  }

  openComponentVideo(index: number, chunk: number) {
    this.retorno();
    try {
      this.formService.mostrar = false;
      console.log('pubs', this.publications);
      this.formService.publications = this.publications;
      const indexxx = chunk * 4 + index;
      //this.initial_index = indexxx;
      this.formService.index = indexxx;
      this.formService.valueSelect = 'ColeccionRegalos';
      this.formService.mediaTemplate = true;
  
      // Log some information to check the values before opening the component
      console.log('Index:', index);
      console.log('Chunk:', chunk);
      console.log('Indexxx:', indexxx);
    } catch (error) {
      console.error('Error in openComponentVideo:', error);
    }
  }
}
